<template lang="pug">
.product-details.container.mx-auto.px-4.my-8(ref="container")
    .loading(v-if="loading" key="spinner")
        //- TODO: skeleton
        Spinner(:size="10" :thickness="2")
    .details(v-else-if="product" :class="transition" key="details")
        .media(ref="media")
            .active-media(v-if="activeMedia && mediaWidth")
                ProductImage(
                    v-if="activeMedia.type === 'image'"
                    :key="`main-${activeMedia.id}`"
                    :media="activeMedia"
                    :product="product"
                    :preferred-width="mediaWidth"
                )
            .thumbnails(v-if="media.length > 1")
                template(v-for="(el, m) in media")
                    //- :aspect-ratio="9 / 16"
                    PreviewImage(
                        v-if="el.type === 'image'"
                        :key="el.id"
                        :media="el"
                        :product="product"
                        :preferred-width="120"
                        :maximized="el.id === activeMedia.id"
                        @maximize="data => selectMedia(m)"
                    )
        .info.zoom-container
            h2.name {{ name }}<br>
            .nr Artikel-Nr.: {{ nr }}
            .properties
                ProductProperty(
                    v-for="property in properties"
                    :valid="valid"
                    :key="`${product.id}-${property.id}`"
                    :property="property"
                    :active-option="selectedOptions[property.id]"
                    :sellable-articles="sellableArticles"
                    :valid-articles="validArticles"
                    :manage-stock="product.manage_stock"
                    @select="selectPropertyOption"
                )
                .property(v-if="description")
                    .label 
                        label Info*
                    .value
                        span(v-html="description")
                        span.info(role="button" @click.prevent.stop="modal = true") 
                            span.buble !
                    portal(to="modals")
                        Modal(v-if="modal"  @dismiss="modal = false")
                            div.modal <p><strong>Äußerer Zustand:</strong></p> <p><strong>BL</strong>=BAD LABEL/stark beschädigtes Etikett, <strong>BS</strong>=BIN SOILED/verschmutztes Etikett, <strong>DC</strong>=DAMAGED CAP/beschädigte Kapsel,<br> <strong>DL</strong>=DAMAGED LABEL/beschädigtes Etikett, <strong>NC</strong>=NO CAP/ohne Kapsel, <strong>NL</strong>=NO LABEL/ohne Etikett, <strong>s</strong>=slightly/leicht, <strong>v</strong>=very/sehr</p> <p><strong>Füllhöhe:</strong></p> <p><strong>hf</strong>=high fill, <strong>in</strong>=into neck, <strong>bon</strong>=base of neck, <strong>vts</strong>=very top shoulder,<br> <strong>ts</strong>=top shoulder, <strong>hs</strong>=high shoulder, <strong>ms</strong>=mid shoulder, <strong>ls</strong>=low shoulder</p> <p><strong>Verpackung:</strong></p> <p><strong>OHK</strong>=Original Holzkiste: <strong>OHK1</strong>=OHK à 1 Fl., <strong>OHK3</strong>=OHK à 3 Fl.,<br> <strong>OHK6</strong>=OHK à 6 Fl., <strong>OHK12</strong>=OHK à 12 Fl., <strong>OHK24</strong>=OHK à 24 Fl.</p> <p><strong>OK</strong>=Original Karton, <strong>BOX</strong>=Original Spezial Box/Etui</p> <p><strong>Bewertung / Punkte:</strong></p> <p><strong>RP</strong>=Robert Parker (Wine Advocate), <strong>WS</strong>=Wine Spectator,<br> <strong>WW</strong>=WeinWisser (Rene Gabriel)</p>
            .price-wrap
                .price {{ price }}
                .tax-info Inkl. MwSt (19%)
            .buttons(:class="{ active: validPropertySelection && validArticles && validArticles.length === 1 }")
                .left
                    .custom-number-input
                        button.decrease(@click="qty = Math.max(1, qty - 1)")
                            span.m-auto.text-2xl.font-thin &minus;
                        input.border-black.border-solid.border-1(type="number" name="custom-input-number" v-model="qty")
                        button.increase(@click="qty = Math.min(maxQty, qty + 1)")
                            span.m-auto.text-2xl.font-thin +
                .right
                    button.button.add-to-shopping-cart(v-if="valid" @click="addToCart") In den Warenkorb
            
    .not-found(v-else key="not-found")
        Error.error(:code="404" message="Produkt konnte nicht gefunden werden")
</template>

<script>
import uniqid from 'uniqid';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import { get, debounce, cloneDeep } from '@/helpers';
import { moneyFormat } from '@/filters';

import Error from '@/components/Error';
import ProductImage from '@/extensions/shop/components/ProductImage';
import PreviewImage from '@/extensions/shop/components/PreviewImage';
import ProductProperty from '@/extensions/shop/components/ProductProperty';
import Modal from '@/components/Modal';

export default {
    name: 'ProductDetailPage',
    data: () => ({
        modal: false,
        loading: false,
        product: undefined,
        modalData: 'Äußerer Zustand:<br>',
        m: 0, // active media key
        mediaWidth: undefined,
        selectedOptions: {}, // key is property id
        transition: {
            // transition classes
            'slide-fade-enter': true,
            'slide-fade-enter-active': false,
            'slide-fade-leave-active': false,
            'slide-fade-leave-to': false
        },
        qty: 1
    }),
    components: {
        Modal,
        Error,
        ProductImage,
        PreviewImage,
        ProductProperty
    },
    watch: {
        qty(value) {
            if (value < 1) this.qty = 1;
            else if (value > this.maxQty) this.qty = this.maxQty;
        }
    },
    computed: {
        nr() {
            return this.product.nr;
        },
        name() {
            let name = this.product.name;

            if (this.validArticles && this.validArticles.length && this.validArticles[0].name) {
                name = this.validArticles[0].name;
            }

            return name;
        },
        description() {
            let description = get(this.product, 'description');
            // if (!description) description = this.productProperties.find(el => el.key === 'buchinfo');
            // if (!description) description = '';
            // if (typeof description == 'object') return description.value;

            if (this.validArticles && this.validArticles.length && this.validArticles[0].description)
                description = this.validArticles[0].description;
            return description;
        },
        media() {
            let media = this.product.media;

            if (
                this.validArticles &&
                this.validArticles.length &&
                this.validArticles[0].media &&
                this.validArticles[0].media.length
            )
                media = this.validArticles[0].media;

            media = media.filter(el => {
                return get(el, 'settings.show.detail', true) === true;
            });

            return media;
        },
        properties() {
            let properties = [];

            const normalizePropertyOptions = el => {
                const propType = el.property.propType;
                let options = el.values.map(el => {
                    const key = propType.value_field;
                    const value = get(el, key);

                    let valueAlt;
                    const keyAlt = propType.value_field_alt;
                    if (keyAlt) valueAlt = get(el, keyAlt);

                    return {
                        id: el.id,
                        image: el.image,
                        value,
                        valueAlt,
                        key
                    };
                });
                return options;
            };

            if (this.product.propertyPivots && this.product.propertyPivots.length) {
                this.product.propertyPivots.forEach(el => {
                    const id = el.property.id;
                    const label = el.property.name;
                    const visible = el.property.visible_on_product_listing;
                    const type = el.property.propType.key;

                    // const propType = el.property.propType;
                    const articleRequired = el.property.article_required;

                    // let key = el.key
                    const options = normalizePropertyOptions(el);
                    let property = {
                        id,
                        type,
                        label,
                        options,
                        articleRequired,
                        visible
                    };

                    // if (el.key.toLowerCase() === 'länge') {
                    //   property.label = 'length';
                    // }
                    properties.push(property);
                });
            }

            return properties.filter(property => {
                return property.visible !== false || property.options.length > 1;
            });
        },
        valid() {
            // check if this product is valid
            // by required stuff is missing
            // - price
            // ...
            return !!this.product.price;
        },
        price() {
            if (!this.product.price) return null;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            // return moneyFormat(price.value - tax, code);
            let string = moneyFormat(this.product.price.value, code);

            // get all prices from related articles
            // define range

            let range = {
                from: this.product.price.value,
                to: this.product.price.value
            };

            if (this.validArticles && this.validArticles.length) {
                this.validArticles.forEach(article => {
                    if (article.price) {
                        range.from = Math.min(range.from, article.price.value);
                        range.to = Math.max(range.from, article.price.value);
                    }
                });

                if (range.from < range.to) string = 'ab ' + moneyFormat(range.from, code);
            }

            return string;
        },
        maxQty() {
            let maxQty = Infinity;
            if (this.validArticles && this.validArticles.length === 1 && this.validArticles[0].qty_sum !== null)
                maxQty = this.validArticles[0].qty_sum;
            return maxQty;
        },
        activeMedia() {
            const m = Math.min(this.media.length - 1, this.m);
            return this.media[m];
        },
        configurableArticleProperties() {
            return this.properties.filter(property => {
                return property.options && property.options.length > 1 && property.articleRequired;
            });
        },
        configurableProductProperties() {
            return this.properties.filter(property => {
                return property.options && property.options.length > 1 && property.articleRequired === false;
            });
        },
        nonConfigurableProperties() {
            return this.properties.filter(property => property.options && property.options.length <= 1);
        },
        validPropertySelection() {
            let valid = false;
            const pendingProperties = this.properties.filter(property => {
                return property.options.length > 1 && !this.selectedOptions[property.id];
            });
            if (!pendingProperties.length) valid = true;
            return valid;
        },
        sellableArticles() {
            let articles = this.product.articles;

            // pay attention to stock
            const manageStock = this.product.manage_stock;
            if (manageStock && this.product.articles && this.product.articles.length)
                articles = this.product.articles.filter(article => article.qty_sum > 0);
            return articles;
        },
        validArticles() {
            let articles = this.sellableArticles;
            if (this.sellableArticles && this.sellableArticles.length) {
                articles = this.sellableArticles.filter(article => {
                    let match = true;

                    // check qty in cart
                    // qty in cart must be smaller
                    // than article.qty_sum (if manageStock)
                    if (this.product.manage_stock) {
                        let cartQty = 0;
                        this.cart.articlePivots.forEach(articlePivot => {
                            if (articlePivot.article.id === article.id) cartQty += articlePivot.qty;
                        });
                        if (article.qty_sum <= cartQty) match = false;
                    }
                    // all property pivots must match
                    if (match) {
                        article.propertyPivots.forEach(el => {
                            const property = el.property;
                            const value = el.value;
                            if (this.selectedOptions[property.id]) {
                                const option = this.selectedOptions[property.id];
                                if (value[option.key] !== option.value) match = false;
                            }
                        });
                    }
                    return match;
                });
            }
            return articles;
        },
        ...mapGetters({
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            defaultTax: 'shop/defaultTax',
            cart: 'shop/cart'
        })
    },
    methods: {
        calculateMediaWidth() {
            if (this.$refs.media) {
                const style = getComputedStyle(this.$refs.media);
                this.mediaWidth = this.$refs.media.clientWidth;
                this.mediaWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            }
        },
        selectMedia(m) {
            this.m = m;
        },
        selectPropertyOption({ property, option }) {
            if (this.selectedOptions[property.id] && this.selectedOptions[property.id].id === option.id) {
                this.$delete(this.selectedOptions, property.id);
            } else {
                const value = { label: property.label, articleRequired: property.articleRequired, ...option };
                this.$set(this.selectedOptions, property.id, value);
                // check if there are validArticles
                // if not delete all selectedOptions
                // that are not available in combination
                // with the latest selection

                if (this.sellableArticles.length) {
                    let attempts = 0;
                    while (!this.validArticles.length && attempts < 1) {
                        ++attempts;
                        let match = false;
                        if (!match) {
                            this.properties.forEach(prop => {
                                if (
                                    prop.articleRequired &&
                                    prop.options.length &&
                                    this.selectedOptions[prop.id] &&
                                    prop.id !== property.id
                                ) {
                                    // find sellable article with selected options
                                    // without the current opt
                                    // if there are some, delete this prop from selectedOptions

                                    const articles = this.sellableArticles.filter(article => {
                                        // all property pivots must match
                                        let match = true;
                                        article.propertyPivots.forEach(el => {
                                            const property = el.property;
                                            const value = el.value;
                                            if (prop.id !== property.id && this.selectedOptions[property.id]) {
                                                const option = this.selectedOptions[property.id];
                                                if (value[option.key] !== option.value) match = false;
                                            }
                                        });
                                        return match;
                                    });

                                    if (articles.length) {
                                        this.$delete(this.selectedOptions, prop.id);
                                        match = true;
                                    }
                                }
                            });
                        }
                    }
                }
            }
        },
        addToCart() {
            if (!this.validArticles || this.validArticles.length > 1) {
                const errorMessage = {
                    id: uniqid(),
                    title: 'Fehler',
                    text:
                        'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    type: 'error',
                    autoclose: 8000
                };
                this.addMessage(errorMessage);
            } else {
                let article = this.validArticles[0];
                article.product = cloneDeep(this.product);
                delete article.product.articles;

                let productPropertyValues = [];
                Object.keys(this.selectedOptions).map(key => {
                    if (!this.selectedOptions[key].articleRequired)
                        productPropertyValues.push(this.selectedOptions[key].id);
                });

                this.addArticleToCart({ article, productPropertyValues, qty: parseInt(this.qty) });

                const properties = Object.keys(this.selectedOptions)
                    .map(key => `${this.selectedOptions[key].label}: ${this.selectedOptions[key].value}`)
                    .join('<br>');

                const text = `
                    <p>Der folgende Artikel wurde Ihrem Warenkorb hinzugefügt</p>
                    <blockquote class="mt-2 pl-3 border-l-2 border-white border-opacity-50">
                    <h4 class="text-xl leading-none mb-1">${this.name}</h4>
                    <p class="text-xs mb-2 text-white text-opacity-75">#${this.nr}</p>
                    <p>${properties}</p>
                    <p>Preis: ${this.price}</p>
                    </blockquote>
                `;

                const message = {
                    id: uniqid(),
                    text,
                    type: 'success',
                    autoclose: 4000
                };
                this.addMessage(message);

                this.selectedOptions = {};
                this.qty = 1;
            }
        },
        ...mapMutations({
            setProduct: 'shop/setProduct'
        }),
        ...mapActions({
            addMessage: 'message/add',
            addArticleToCart: 'shop/addArticleToCart',
            fetchProduct: 'shop/fetchProduct'
        })
    },
    mounted() {
        this.loading = true;

        this.fetchProduct({ slug: this.$route.params.product })
            .then(product => {
                this.product = product;
                // this.setProduct(product);
                setTimeout(this.calculateMediaWidth, 0);

                this.transition['slide-fade-enter-active'] = true;
                setTimeout(() => (this.transition['slide-fade-enter'] = false), 0);
                setTimeout(() => (this.transition['slide-fade-enter-active'] = false), 300);
            })
            .finally(() => {
                this.loading = false;
            });

        this.debouncedCalculateMediaWidth = debounce(this.calculateMediaWidth, 100);
        window.addEventListener('resize', this.debouncedCalculateMediaWidth);
    },
    beforeRouteLeave(to, from, next) {
        this.transition['slide-fade-leave-active'] = true;
        this.transition['slide-fade-leave-to'] = true;
        next();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.debouncedCalculateMediaWidth);
    }
};
</script>

<style lang="sass" scoped>

@import "~@/assets/sass/variables"

::v-deep .modal
    @apply text-center p-6
    p
        @apply pb-3
    strong
        @apply font-semibold

.loading > section
    min-height: 140px
.thumbnails
    display: flex
    flex-wrap: wrap
    justify-content: center
    margin: 2rem 0
    gap: 1rem

.media
    margin-top: -1rem
    margin-bottom: 1rem
    @screen sm
        margin-top: 0
.name
    font-size: 2rem
    line-height: 1.1
    small
        font-size: 1rem
        top: -0.3rem
        position: relative
.nr
    margin-bottom: 1rem
    @screen sm
        margin-bottom: 2rem
.properties
    @apply table w-full
    margin-bottom: 2rem
    .property
        @apply table-row
        ::v-deep
            div
                @apply table-cell border-b border-solid
                padding: 6px 10px
                border-color: $maisonvin-border
            .label
                @apply text-right font-medium
                width: 50%
            .value
                font-weight: 350
                span
                    @apply inline-block
                    span.buble
                        @apply ml-2 rounded-full h-4 w-4 flex items-center justify-center text-white transition duration-300 ease-in-out
                        background-color: $maisonvin-red-dark
                        &:hover
                            transform: scale(1.1)
                            background-color: $maisonvin-red
    .property
        margin-bottom: 1rem
.price-wrap
    text-align: right
    margin-bottom: 1rem
    .price
        font-size: 2rem
    .tax-info
        font-size: 0.9rem
    // margin-bottom: 3rem

.details
    position: relative
    ::v-deep .drift-zoom-pane
        @apply rounded overflow-hidden
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 80vh

.add-to-shopping-cart
    @apply border-gray-600 rounded-none transition duration-300 ease-in-out
    background: $maisonvin-red-dark
    &:hover
        color: $maisonvin-red
.buttons
    @apply flex
    justify-content: space-between
    opacity: .3
    pointer-events: none
    transition: opacity .15s ease
    margin-bottom: 5rem
    &.active
        pointer-events: initial
        opacity: 1
    .left
        display: flex
        flex-grow: 1
        justify-content: flex-end
        padding-right: 1rem

.custom-number-input
    @apply w-32 flex flex-row rounded-lg relative
    button
        @apply bg-white text-gray-600 h-full w-20 cursor-pointer outline-none
        height: 2.5rem
        &:hover,
        &:focus
            @apply text-gray-700 bg-gray-100
        &.decrease
            @apply rounded-l
        &.increase
            @apply rounded-r
    input
        @apply outline-none rounded-none text-center w-full bg-white font-semibold flex items-center text-gray-700
        @apply shadow-none #{! important}
        height: 2.5rem
        &:hover,
        &:focus
            @apply text-black

@screen md
    .product-details
        display: flex
        flex-grow: 1
        & > div
            width: 100%
        .loading
            display: flex
            width: 100%
        .details
            display: grid
            grid-template-rows: auto
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr)
            grid-gap: 3rem
    .info
        position: relative
        ::v-deep .drift-zoom-pane
            @apply rounded overflow-hidden
            position: absolute
            left: -5rem
            top: 0
            width: calc(100% + 5rem)
            height: 60vh

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button
    -webkit-appearance: none
    margin: 0

.custom-number-input input:focus
    outline: none !important

.custom-number-input button:focus
    outline: none !important
</style>
